import {createSelector} from '@ngrx/store';

import * as fromCitizensServicesDeliveryChannel from './citizens-services-delivery-channel.reducer';
import {AppState} from 'src/app/store/reducers';


export const currentState = (state: AppState) => (state[fromCitizensServicesDeliveryChannel.citizensServicesDeliveryChannelsFeatureKey]);

export const selectCitizenServiceDeliveryChannel = createSelector(currentState, fromCitizensServicesDeliveryChannel.selectAll);

export const selectTotolCitizenServiceDeliveryChannel = createSelector(currentState, fromCitizensServicesDeliveryChannel.selectTotal);

export const selectModifiedServiceDeliveryChannel = createSelector(selectCitizenServiceDeliveryChannel, (citizens) => {
  return citizens.map((citizen) => {
    return {
      ...citizen
    };
  });
});
